<template>
    <form-row title="Name">
        <input-text
            class="w-full"
            name="name"
            :value="broker.name"
            placeholder="Name"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        broker: { default: () => ({}) },
    },
}
</script>
